import {
  createClient,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory,
  UnpagedSearchOperation,
  unpagedSearchRequestFactory
} from '@infuse/api/common';

import { Transaction } from './model';

const client = createClient('/rest/operator-api/transactions');

export const transactionPermissions = {
  SEARCH: 'cpms.search-transactions',
  GET: 'cpms.get-transaction',
  DOWNLOAD_CSV: 'cpms.download-transactions-csv',
  FORCE_STOP: 'cpms.force-stop-transaction'
};

export const downloadTransactions: UnpagedSearchOperation<string> = unpagedSearchRequestFactory<string>(client, {
  pattern: '/csv',
  permissionId: transactionPermissions.DOWNLOAD_CSV
});
export const getTransaction: FindOperation<Transaction, number> = getRequestFactory<Transaction, number>(client, {
  permissionId: transactionPermissions.GET
});
export const searchTransactions: SearchOperation<Transaction> = searchRequestFactory<Transaction>(client, {
  permissionId: transactionPermissions.SEARCH
});

export interface ForceStopTransactionCommand {
  stopAt?: Date
}

export const forceStopTransaction: SaveOperation<ForceStopTransactionCommand, void, string> = postRequestFactory<
  ForceStopTransactionCommand,
  void,
  string
>(client, {
  pattern: '/{id}/force-stop',
  permissionId: transactionPermissions.FORCE_STOP
});
